import { useTranslation } from "react-i18next";
import ChartContent from "./chart-content/ChartContent";

import "./style.scss";

export const App = () => {
	const { t } = useTranslation();

	return (
		<div className="marine-forecast-chart">
			<p className="title"> {t("marineForecastChart")} </p>
			<ChartContent />
		</div>
	);
};

export default App;
